module.exports = __webpack_public_path__ + "img/Group 1321316819@2x.aac64779.png";